import React, { useCallback } from 'react';
import { Menu, Dropdown, Col } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
// import Dots from '../../../../../components/Icon/Dots';
import MasterCardLogo from '../../../assets/images/mastercard-logo.svg';
// import { save, remove } from '../../services/providers/settings/payment_card';
// import { get } from '../../../../../modules/settings/payment-cards';

function CreditCard({ cardData, getData, getPaymentCards }) {
  const { name, exp_month, exp_year, is_default, brand, last4 } = cardData;

  return (
    <div className="credit-card-list-item">
      <div className="credit-card-list-item-logo">
        <img src={MasterCardLogo} alt="Mastercard Logo" className="img-responsive" />
      </div>
      <div className="credit-card-list-item-card">
        <div className="credit-card-list-item-card-number">
          ****&nbsp;&nbsp;****&nbsp;&nbsp;****&nbsp;&nbsp;{last4}
        </div>
        <div className="credit-card-list-item-card-name">
          {brand}
        </div>
      </div>
    </div>
  );
}

export default connect(null, {})(CreditCard);



// WEBPACK FOOTER //
// ./src/containers/Subscriptions/components/CreditCard.js